export default __webpack_public_path__ + "b2e307e07d78df6478488b255eb81e4b.png";